import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { useDispatch, useSelector } from "react-redux"
import { useHiddenSidebar } from "hooks"
import useSurveyRecipientsIndexSettings from "hooks/useSurveyRecipientsIndexSettings"
import { LargeWrap } from "shared/wraps"
import * as API from "services/api"
import { errorToast } from "shared/toast"
import LoadingIndicator from "shared/LoadingIndicator"
import paginatedResourceList from "utils/paginatedResourceList"
import withReduxProvider from "shared/withReduxProvider"
import { getSurveyRecipients, setSurveyRecipients } from "reduxSlices/surveyRecipientTableSlice"
import RecipientsHeader from "./RecipientsHeader"
import Sidebar from "./Sidebar"
import SurveyRecipientList from "./SurveyRecipientList"

const SurveyRecipientIndex = () => {
  useSurveyRecipientsIndexSettings()

  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const { hiddenSidebar, toggleSidebar } = useHiddenSidebar()

  const recipientList = useSelector(getSurveyRecipients)

  useEffect(() => {
    const fetchAllRecipients = async () => {
      try {
        const recipients = await paginatedResourceList({ apiFunction: API.getSurveyRecipients })()
        dispatch(setSurveyRecipients(recipients))
      } catch {
        errorToast("Something went wrong. Unable to load survey recipients.")
      } finally {
        setIsLoading(false)
      }
    }

    fetchAllRecipients()
  }, [dispatch])

  return (
    <>
      <Sidebar hiddenSidebar={hiddenSidebar} />
      <LargeWrap className={clsx(!hiddenSidebar && "pl-80")}>
        <RecipientsHeader hiddenSidebar={hiddenSidebar} toggleSidebar={toggleSidebar} />
        {
          isLoading
            ? <LoadingIndicator />
            : <SurveyRecipientList recipientList={recipientList} />
        }
      </LargeWrap>
    </>
  )
}

export default withReduxProvider(SurveyRecipientIndex)
